import type { InternalQuery } from "@v2/features/analytics/utils/query";
import type {
  AnalyticsQuery,
  AnalyticsQueryFilters,
  MetricName,
} from "schemas/generated/analyticsRead";

export const RESULTS_PER_PAGE = 25;

const DEFAULT_SORT_METRIC: MetricName = "unique_sessions";
const DEFAULT_QUERY_RESULT_LIMIT = RESULTS_PER_PAGE;
const DEFAULT_QUERY_RESULT_OFFSET = 0;
const DEFAULT_ORDER: AnalyticsQuery["order"] = "DESC";

export const DEFAULT_METRICS: AnalyticsQuery["metrics"] = [
  "conversions",
  "views",
  "conversion_rates",
  "unique_sessions",
  "revenue",
  "revenue_per_session",
  "average_order_value",
];

export const DEFAULT_FILTERS: AnalyticsQueryFilters = {
  urlPath: [
    {
      operator: "does_not_contain",
      value: "/checkouts/",
    },
    {
      operator: "does_not_contain",
      value: "/orders/",
    },
    {
      operator: "does_not_contain",
      value: "/tools/recurring/portal/",
    },
    {
      operator: "does_not_contain",
      value: "/account/",
    },
  ],
  pageType: "entryPages",
  urlParams: {},
};

export const DEFAULT_QUERY: InternalQuery = {
  order: DEFAULT_ORDER,
  sortMetric: DEFAULT_SORT_METRIC,
  metrics: DEFAULT_METRICS,
  offset: DEFAULT_QUERY_RESULT_OFFSET,
  limit: DEFAULT_QUERY_RESULT_LIMIT,
};

export const METRICS_REQUIRING_DECIMALS: MetricName[] = [
  "revenue",
  "revenue_per_session",
  "conversion_rates",
  "average_order_value",
];

export const METRICS_REQUIRING_PERCENTAGE: MetricName[] = ["conversion_rates"];
export const METRICS_REQUIRING_CURRENCY: MetricName[] = [
  "revenue",
  "revenue_per_session",
  "average_order_value",
];

export const METRICS_ALLOWING_ZERO_VALUE_WHEN_NO_DATA: MetricName[] = [
  "revenue",
  "unique_sessions",
  "conversions",
];
